import React, { useState } from 'react';
import { Form, Button, Container, Row, Col, Alert } from 'react-bootstrap';

function InstituteRegistration({ onRegistered, setInstituteView }) {

  const [form, setForm] = useState({
    name: '',
    email: '',
    password: '',
    contactPerson: '',
    phone: '',
  });
  const [message, setMessage] = useState('');

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setMessage('');

    try {
      const response = await fetch('/api/institute/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(form)
      });

      const data = await response.json();

      if (response.ok) {
        setMessage(
          `Welcome, ${data.institute.name.toUpperCase()}! Please log in with your email and password.`
        );
        // Optionally clear the form:
        setForm({
          name: '',
          email: '',
          password: '',
          contactPerson: '',
          phone: '',
        });
      } else {
        setMessage(data.message || 'Registration failed.');
      }
    } catch (err) {
      setMessage('Something went wrong. Please try again.');
      console.error(err);
    }
  }

  return (
    <Container className="mt-5">
      <Row className="justify-content-md-center">
        <Col xs={12} md={8} lg={6}>
          <h1
            className="mb-4 text-center"
            style={{
              fontSize: '2.5rem',
              fontWeight: 'bold',
              color: '#ffffffff',
              letterSpacing: '1px',
              textShadow: '0 4px 14px rgba(42, 82, 152, 0.12)',
            }}
          >
            INSTITUTE REGISTRATION
          </h1>

          <Form onSubmit={handleSubmit} className="p-4 rounded shadow bg-white">
            <Form.Group className="mb-3" controlId="formName">
              <Form.Label>Institute Name*</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                required
                placeholder="Enter institute name"
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formEmail">
              <Form.Label>Email*</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                required
                placeholder="Enter institute email"
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formPassword">
              <Form.Label>Password*</Form.Label>
              <Form.Control
                type="password"
                name="password"
                value={form.password}
                onChange={handleChange}
                required
                placeholder="Create a password"
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formContactPerson">
              <Form.Label>Contact Person*</Form.Label>
              <Form.Control
                type="text"
                name="contactPerson"
                value={form.contactPerson}
                onChange={handleChange}
                placeholder="Contact person at institute"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formPhone">
              <Form.Label>Phone*</Form.Label>
              <Form.Control
                type="tel"
                name="phone"
                value={form.phone}
                onChange={handleChange}
                placeholder="Phone number"
                required
              />
            </Form.Group>

            <div className="text-center mb-3">
              <span style={{ color: "red", fontWeight: "bold", fontSize: "1rem" }}>
                Please complete your profile after registration and add your programs and departments.
              </span>
            </div>
            <div className="d-grid">
              <Button variant="primary" type="submit">
                Register
              </Button>
            </div>
            <div className="text-center mt-3">
  <Button
    variant="link"
    onClick={() => setInstituteView && setInstituteView("login")}
    style={{ color: "#6a1b9a", fontWeight: 500, fontSize: "1.1rem" }}
  >
    Already have an account? Login
  </Button>
</div>

          </Form>
          {message && (
            <Alert
              variant={
                message.toLowerCase().includes('fail') ||
                message.toLowerCase().includes('must be at least') ||
                message.toLowerCase().includes('already') ||
                message.toLowerCase().includes('wrong') ||
                message.toLowerCase().includes('error')
                  ? 'danger'
                  : 'success'
              }
              className="mt-3 text-center"
            >
              {message}
            </Alert>
          )}
        </Col>
      </Row>
    </Container>
  );
}

export default InstituteRegistration;
